import React, {useEffect, useState} from 'react';
import {BoldCollapseText, FlexColumnSection, SeparatorHorizontal} from "../../../styles/globalStyles";
import './ChildSelection.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {t} from "i18next";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import ChildDetails from "./ChildDetails";
import {useDispatch, useSelector} from "react-redux";
import {updateFlags} from "@arboxappv4/shared/src/redux/stepperSlice";
import dayjs from "dayjs";
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";
import {Badge} from "antd";

const ChildSelection = (props) => {
    const { values, setFieldValue, handleSubmit, errors } = props;
    const userBox = useSelector(state => state.user.activeUsersBoxes)
    const [childrenArr, setChildrenArr] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        setFieldValue('isNewChild', false)
        setFieldValue('child', {})
        dispatch(updateFlags({isNewChild: false}))
    }, []);

    useEffect(() => {
        if(userBox) {
            getChildrenOptions()
        }
    }, [userBox]);

    useEffect(() => {
        if(values.child?.child_id && submitted) {
            handleSubmit()
        }
    }, [values.child?.child_id, submitted]);

    const getChildrenOptions = async () => {
        if(userBox.group_connection) {
            let children = userBox.group_connection.group_members.filter(groupConnection => groupConnection.id !== userBox.group_connection.users_boxes_id)
            const bookedUsers = await apiAction('site/checkChildBookedToHugAlready', 'post', {users: children, series_id: values.course?.id});
            if(bookedUsers.length) {
                children = children.map(child => ({...child, booked: bookedUsers.includes(child.user_fk)}))
            }
            setChildrenArr(children)
        }
    }

    const onChildSelected = (groupConnection) => {
        setFieldValue('isNewChild', false)
        setFieldValue('child.child_id', groupConnection.user_fk)
        setSubmitted(true)
    }

    const onAddChild = () => {
        setFieldValue('isNewChild', true)
        dispatch(updateFlags({isNewChild: true}))
    }

    if(!childrenArr) return null

    return (
        <div className={'child-selection-wrapper'}>
            {values?.isNewChild ? <ChildDetails {...props}/> :
            <FlexColumnSection align={'start'} padding={'0 5px'}>
                <div className={'children-wrapper'}>
                    {childrenArr.map(item => (
                        <>
                            {item.booked ?
                                <div className={'disabled'}>
                                <Badge.Ribbon text={<div style={{color: Colors.badgeGreenText}}>{t('booked')}</div>} color={Colors.badgeGreen}>
                                    <div className={'white-option disabled'} key={`child-selection-${item.id}`}>
                                        <BoldCollapseText>{item.full_name}</BoldCollapseText>
                                        <div className={'child-info'}>
                                            {item.birthday && <div className={'child-info-text'}>{t('age-label')}: {dayjs().diff(item.birthday, 'year')}</div>}
                                            {item.personal_id && <div className={'child-info-text'}>{t('id-label')}: {item.personal_id}</div>}
                                        </div>
                                    </div>
                                </Badge.Ribbon>
                                </div>
                                :
                                <div onClick={() => onChildSelected(item)} className={'white-option'} key={`child-selection-${item.id}`}>
                                    <BoldCollapseText>{item.full_name}</BoldCollapseText>
                                    <div className={'child-info'}>
                                        {item.birthday && <div className={'child-info-text'}>{t('age-label')}: {dayjs().diff(item.birthday, 'year')}</div>}
                                        {item.personal_id && <div className={'child-info-text'}>{t('id-label')}: {item.personal_id}</div>}
                                    </div>
                                </div>
                            }
                        </>

                    ))}
                </div>
                <SeparatorHorizontal margin={'20px 0'}/>
                <div onClick={onAddChild} style={{width: '100%'}}>
                    <div className={'white-option add-child'}>
                        <FontAwesomeIcon icon={solid('plus')} color={Colors.siteBlack}/>
                        <BoldCollapseText>{t('new-child')}</BoldCollapseText>
                    </div>
                </div>
            </FlexColumnSection>}
        </div>
    );
};

export default ChildSelection;
